import MonthlyInfluenceV2 from '../pages/MonthlyInfluenceV2/pages/index/reducers'

export default {
  MonthlyInfluenceV2,
}
